import { API_BASE_URL } from './env'
import { readEnv } from './runtimeConfig'

function normalizeString(value?: string): string | undefined {
  const normalizedValue = value?.trim()
  return normalizedValue ? normalizedValue : undefined
}

function parseSampleRate(value?: string): number {
  const normalizedValue = normalizeString(value)
  if (!normalizedValue) return 0

  const parsedValue = Number(normalizedValue)

  return Number.isFinite(parsedValue) && parsedValue >= 0 && parsedValue <= 1 ? parsedValue : 0
}

function parseTracePropagationTargets(value?: string): string[] {
  return (value ?? '')
    .split(',')
    .map((entry) => normalizeString(entry))
    .filter((entry): entry is string => Boolean(entry))
}

export const sentryConfig = {
  dsn: normalizeString(readEnv('VITE_SENTRY_DSN')),
  environment: normalizeString(readEnv('VITE_SENTRY_ENVIRONMENT')),
  release: normalizeString(readEnv('VITE_SENTRY_RELEASE')),
  tracesSampleRate: parseSampleRate(readEnv('VITE_SENTRY_TRACES_SAMPLE_RATE')),
  replaysSessionSampleRate: parseSampleRate(readEnv('VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE')),
  replaysOnErrorSampleRate: parseSampleRate(readEnv('VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE')),
  tracePropagationTargets: Array.from(
    new Set([
      API_BASE_URL,
      ...parseTracePropagationTargets(readEnv('VITE_SENTRY_TRACE_PROPAGATION_TARGETS')),
    ]),
  ),
}

export const isSentryEnabled = Boolean(sentryConfig.dsn)
